import HTTP from '../libs/HTTP';

//query接口请求参数
export interface AdminQueryParam {
    id?: number;
    account?: string;
    role?: number;
    realName?: string;
    states?: number;
}
export interface AdminListRequest {
    adminQueryParam: AdminQueryParam;
    pageNo: number;
    pageSize: number;
}

//query接口返回参数
export interface IAdminInfoList {
    records: IAdminInfo[];
    total: number;
    size: number;
    current: number;
    pages: number;
}
export interface IAdminInfo {
    id: number;
    account: string;
    role: number;
    realName?: string | null;
    avatar?: string | null;
    states: number;
}

//add接口请求参数
export interface AdminPostParam {
    account: string;
    password: string; 
    role: number;
    realName: string;
    avatar?: string;
    states: number;
}

//edit接口请求参数
export interface AdminPutParam {
    id: number;
    account?: string;
    password?: string; 
    role?: number;
    realName?: string;
    avatar?: string;
    states?: number;
}

class AdminService extends HTTP {

    //查询当前登录账号的信息
    async getLoginAccountRoleNumber() {
        const response = await this.get('/admin/getLoginAccountRoleNumber');
        if (response) {
            return response.data;
        }
    }
    
    //查询管理员信息
    async getAdminListInfo(request: AdminListRequest) {
        const response = await this.post('/admin/getAdmin', request.adminQueryParam, {
            params: {
                pageNo: request.pageNo,
                pageSize: request.pageSize,
            },
        });
        if (response) {
            return response.data;
        }
    }
    
    //查询销售信息
    async getSalesListInfo() {
        const response = await this.get('/admin/getSales');
        if (response) {
            return response.data;
        }
    }

    //查询项目经理信息
    async getProjectManagerListInfo() {
        const response = await this.get('/admin/getProjectManagers');
        if (response) {
            return response.data;
        }
    }

    //添加管理员
    async addAdmin(request: AdminPostParam) {
        const response = await this.post('/admin/addAdmin', request, {
            params: {
                account: request.account,
                password: request.password,
                role: request.role,
                realName: request.realName,
                avatar: request.avatar,
                states: request.states,
            },
        });
        if (response) {
            return response.data;
        }
    }

    //编辑管理员
    async updateAdmin(request: AdminPutParam) {
        const response = await this.put(`/admin/updateAdmin/${request.id}`, request, {
            params: {
                account: request.account,
                password: request.password,
                role: request.role,
                realName: request.realName,
                avatar: request.avatar,
                states: request.states,
            },
        });
        if (response) {
            return response.data;
        }
    }

}
export default new AdminService();
